<template>
<div>

    <div class="modal" id="modalEpsonDailyClosure" tabindex="-1" data-backdrop="static" data-keyboard="false" >
        <div class="modal-dialog modal-dialog-centered"> 
    

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>CHIUSURA FISCALE GIORNALIERA</strong>
    <hr>
    <span>{{ data.url }}</span>
  </h4>  
</div>

<div class="modal-body">
  <div>

  </div>
  <button @click="closeModal()" type="button" class="btn btn-secondary float-left mt-2">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
  </button>

  <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary float-right mt-2">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA CHIUSURA
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>  

</div>
</div>


</div>
</div>

</div>


</template>

<script>


import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'
import { mapGetters }    from 'vuex'

  export default {

  props : ['data'],

     components: {alertBox},
    data () {
      return {
        
          msg         : {title : '',body:'',type :0},          
          url         : '',
          bt_spinner  : false

                                   
      }
    },

    
    computed: {
     ...mapGetters(['company']),
      
    },
    mounted ()
    {
        $('#modalEpsonDailyClosure').modal('show')  
    },
    created () 
      {
        console.log('EPSON DAILY CLOSURE CREATED',this.data)
        //this.getSaleData()
      },
    
    methods: 
    {
    
    closeModal()
    {
        $('#modalEpsonDailyClosure').modal('hide')
        this.$nextTick(()  => {              
        this.$emit('close')        
    })    
    },
    getXML() 
     {
        
        let xml = ''  
        xml = '<printerFiscalReport>'
        xml += '<displayText operator="1" data="CHIUSURA GIORNALIERA" />'    
            
        xml +='<printXZReport operator="1" timeout="30000" />'
        xml += '</printerFiscalReport>'
        
        
        console.log('EPSON DAILY CLOSURE',xml)  

        return xml              
      },
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      postXML()
      {   
          
          this.bt_spinner = true
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : this.data.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('RT Response',res)
                this.closeModal()
                  
                            
             }).catch(err => {
               this.bt_spinner = false                             
               console.log('Errore RT',err)  
             })
       
      },    
           
   
     } 
      

    
  }
</script>
<style scoped>

  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
